import { c as _c } from "react/compiler-runtime";
import { Badge, Button, Text, VStack } from '@chakra-ui/react';
import { roomEndedCopy, sessionStatusPalette } from '@src/components/sco/Advisors/utils/sessionStatus';
import { NextLink } from '@src/components/sco/utilities/NextLink';
type SessionRoomEndedProps = {
  statusKey?: string | null;
  statusTitle?: string | null;
  detailHref: string;
};
export const SessionRoomEnded = t0 => {
  const $ = _c(14);
  const {
    statusKey,
    statusTitle,
    detailHref
  } = t0;
  let t1;
  if ($[0] !== statusKey || $[1] !== statusTitle) {
    t1 = statusTitle ? <Badge colorPalette={sessionStatusPalette(statusKey)} variant="subtle">{statusTitle}</Badge> : null;
    $[0] = statusKey;
    $[1] = statusTitle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Text fontWeight="semibold">This call ended</Text>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== statusKey) {
    t3 = roomEndedCopy(statusKey);
    $[4] = statusKey;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <Text color="fg.onStageMuted" fontFamily="longform" fontSize="sm" maxWidth="42rem">{t3}</Text>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== detailHref) {
    t5 = <Button asChild={true} size="sm" variant="cta"><NextLink href={detailHref}>Back to session</NextLink></Button>;
    $[8] = detailHref;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t1 || $[11] !== t4 || $[12] !== t5) {
    t6 = <VStack align="flex-start" gap={4} padding={6}>{t1}{t2}{t4}{t5}</VStack>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};